import featureFlags from "./featureFlags";

interface DefaultDatabaseType {
  databaseType: string;
}

const getDefaultDatabaseType = (): string => {
  if (featureFlags.gfli3) return "GFLI_3_0";
  if (featureFlags.databaseGFLI_2_2) return "GFLI_2_2";
  return "GFLI";
};

// eslint-disable-next-line import/prefer-default-export
export const initialDBSelection: DefaultDatabaseType = {
  databaseType: getDefaultDatabaseType(),
};
